<div id="st-main-header-wrapper" class="st-header-container"
  [ngStyle]="{ 'border-bottom': isRegistrationTravelRoute() ? 'none' : 'none' }">
  <!-- nav-tabs-compact is used to compact the tabs when the screen is small -->
  <nav id="st-main-navbar" class="navbar navbar-light st_common_high_padditenant_nameng"
    [class.search-active]="isSearchExpanded"
    [class.nav-tabs-compact]="visibleNavTabCount > navTabsCompactThreshold"
    [ngClass]="{
      st_common_high_padding: innerWidth > 1024,
      tab_padding: innerWidth < 1024 && innerWidth > 500,
      'mobile_padding ': innerWidth < 499
    }">
    <div id="st-container-1" class="d-flex justify-content-between w-100 align-items-center h-100">
      <div id="st-nav-left-2" class="gap-4 d-flex align-items-center nav-left">
        <button type="button" id="st-brand-3" class="brand" (click)="openHome()">
          <div id="st-container-4" class="d-flex align-items-center">
            <img class="ps-0 tenant_logo" style="padding: 20px;"
              [ngClass]="{'pe-0': tenant_name == 'ttfi', 'p-0 switz-header-logo': tenant_name == 'switz'}"
              [attr.width]="tenant_name == 'ettu' ? '180' : (tenant_name == 'sbtf' ? '150' :(tenant_name == 'spain' ? '105' : (tenant_name == 'switz' ? '254' : '130')))"
              [src]=" tenant_name == 'switz' ? logo_light : (is_dark ? logo_light : logo_dark)" alt="logo" />
            <img *ngIf="tenant_name == 'ttfi'"
              [src]="is_dark ? '../../../assets/SvgIcons/See Beyond Sport_png.png' : '../../../assets/SvgIcons/See Beyond Sport_svg (2).svg'"
              alt="logo" width="130" height="40" class="tenant_logo"/>
          </div>
        </button>
      </div>
      <div id="st-nav-center-5" class="nav-center">
        <ul class="gap-1 link-row d-flex align-items-center flex-grow-1" *ngIf="innerWidth > 1024">
          <li *ngIf="is_login && isPlayer && show_player_dashboard" class="link-tab"
            [ngClass]="_currentRoute == 'my-profile-dashboard' ? 'selected' : ''"
            (click)="navigateToRegistration('/my-profile-dashboard')"
            (mouseenter)="onTabHover('/my-profile-dashboard')">
            <i class="bi bi-person-badge nav-ico" aria-hidden="true"></i><span
              class="nav-label">{{'my_profile'|translate}}</span>
          </li>
          <li class="link-tab" [ngClass]="_currentRoute == 'home' ? 'selected' : ''"
            (click)="navigateToRegistration('/home')" (mouseenter)="onTabHover('/home')">
            <i class="bi bi-house-door nav-ico" aria-hidden="true"></i><span class="nav-label">{{'home' |
              translate}}</span>
          </li>
          <li class="link-tab" [ngClass]="_currentRoute == 'events' ? 'selected' : ''"
            (click)="navigateToRegistration('/events/1')" (mouseenter)="onTabHover('/events/1')">
            <i class="bi bi-calendar-event nav-ico" aria-hidden="true"></i><span class="nav-label">{{'events' |
              translate}}</span>
          </li>
          @if (showWatchCentreGroup()) {
            <li
              app-header-nav-group
              groupId="watch-centre"
              labelKey="watch_centre"
              iconId="watch-centre"
              [items]="watchCentreNavItems()"
              [currentRoute]="_currentRoute"
              (itemNavigate)="onNavGroupItemNavigate($event)"
              (itemHover)="onTabHover($event)"
            ></li>
          } @else {
            @for (item of watchCentreNavItems(); track item.id) {
              <li
                class="link-tab"
                [ngClass]="_currentRoute === item.route ? 'selected' : ''"
                (click)="onNavGroupItemNavigate(item)"
                (mouseenter)="onTabHover(item.url)"
              >
                <app-header-nav-icon class="nav-ico" [iconId]="item.iconId" />
                <span class="nav-label">{{ item.labelKey | translate }}</span>
              </li>
            }
          }
          <li class="link-tab" [ngClass]="_currentRoute == 'ranking' ? 'selected' : ''"
            (click)="navigateToRegistration('/ranking')" (mouseenter)="onTabHover('/ranking')" *ngIf="useRanking">
            <i class="bi bi-trophy nav-ico" aria-hidden="true"></i><span class="nav-label">{{'ranking' |
              translate}}</span>
          </li>
          @if (showMembershipsGroup()) {
            <li
              app-header-nav-group
              groupId="memberships"
              labelKey="memberships"
              iconId="memberships"
              [items]="membershipsNavItems()"
              [currentRoute]="_currentRoute"
              (itemNavigate)="onNavGroupItemNavigate($event)"
              (itemHover)="onTabHover($event)"
            ></li>
          } @else {
            @for (item of membershipsNavItems(); track item.id) {
              <li
                class="link-tab"
                [ngClass]="_currentRoute === item.route ? 'selected' : ''"
                (click)="onNavGroupItemNavigate(item)"
                (mouseenter)="onTabHover(item.url)"
              >
                <app-header-nav-icon class="nav-ico" [iconId]="item.iconId" />
                <span class="nav-label">
                  @if (item.titlecase) {
                    {{ item.labelKey | translate | titlecase }}
                  } @else {
                    {{ item.labelKey | translate }}
                  }
                </span>
              </li>
            }
          }
          <li class="link-tab" [ngClass]="_currentRoute == 'rating' ? 'selected' : ''"
            (click)="navigateToRegistration('/rating')" (mouseenter)="onTabHover('/rating')" *ngIf="useRating">
            <i class="bi bi-star nav-ico" aria-hidden="true"></i><span class="nav-label">{{'rating' | translate}}</span>
          </li>
          <!-- Forced: do not restore standalone License / Sub-license <li>s here.
               Memberships grouping (or the flat @for) above already owns those
               routes. An unclosed HTML comment previously swallowed copies of
               these tabs; closing it would have duplicated them in the nav. -->
          <li
            class="link-tab"
            *ngIf="false"
            [ngClass]="_currentRoute == 'calendar' ? 'selected' : ''"
            (click)="navigateToRegistration('/videos')"
          >
            {{ 'calendar' | translate }}
          </li>
          <li class="link-tab" *ngIf="false" [ngClass]="_currentRoute == 'leaderboard' ? 'selected' : ''"
            (click)="navigateToRegistration('/videos')">
            {{ "leaderboard" | translate }}
          </li>
        </ul>
      </div>

      <div id="st-container-6" *ngIf="innerWidth > 1024" class="gap-3 d-flex align-items-center nav-right">
        <!-- Search Box with Dropdown — expands inline in place of the icon
             (no backdrop/overlay). The nav tabs switch to compact icon-only
             mode via nav.search-active so the freed-up width is what the
             box grows into, instead of floating on top of the nav. -->
        <div id="st-desktop-search-wrapper" class="search-container" [class.expanded]="isSearchExpanded">
          <!-- Search Icon (visible when collapsed) -->
          <button type="button" id="st-search-icon-btn-7" class="search-icon-btn" *ngIf="!isSearchExpanded"
            (click)="toggleSearch()">
            <svg class="stupa-svg" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
              <circle cx="11" cy="11" r="7" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </button>
          <!-- Search Box (visible when expanded) -->
          <div id="st-search-box-8" class="search-box" *ngIf="isSearchExpanded">
            <svg class="search-icon" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
              <circle cx="11" cy="11" r="7" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input #searchInput type="text" class="search-input" [placeholder]="'search_placeholder' | translate"
              [(ngModel)]="searchQuery" (blur)="onSearchBlur()" (input)="onSearchInput($event)"
              (keydown.escape)="toggleSearch()" />
            <!-- Microphone button (only show if voice search is supported) -->
            <button class="search-mic-btn" *ngIf="isVoiceSearchSupported" [class.listening]="isListening"
              (mousedown)="$event.preventDefault()" (click)="startVoiceSearch()" title="Voice Search">
              <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7 11C8.66 11 9.99 9.66 9.99 8L10 3C10 1.34 8.66 0 7 0C5.34 0 4 1.34 4 3V8C4 9.66 5.34 11 7 11ZM12.3 8C12.3 11 9.76 13.1 7 13.1C4.24 13.1 1.7 11 1.7 8H0C0 11.41 2.72 14.23 6 14.72V18H8V14.72C11.28 14.24 14 11.42 14 8H12.3Z"
                  [attr.fill]="isListening ? '#F04438' : 'currentColor'" />
              </svg>
            </button>
            <!-- Clear button (only when there's text to clear) -->
            <button class="search-clear-btn" *ngIf="searchQuery.length > 0" (mousedown)="clearSearch($event)"
              title="Clear">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
            <span class="search-divider" aria-hidden="true"></span>
            <!-- Close button — always available so the box can be dismissed
                 without relying on a click-away backdrop. -->
            <button class="search-close-btn" (mousedown)="$event.preventDefault()" (click)="toggleSearch()"
              title="Close search">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
          </div>
          <!-- Search Results Dropdown -->
          <div id="st-desktop-search-dropdown" class="search-dropdown" *ngIf="
              isSearchExpanded &&
              searchQuery.length > 0 &&
              searchResults.length > 0
            ">
            <div [id]="'st-search-result-item' + loop_idx_1" class="search-result-item"
              *ngFor="let result of searchResults; let loop_idx_1 = index; trackBy: trackByIndex"
              (mousedown)="onResultClick(result)">
              <span class="result-name">{{ result.name }}</span>
              <div [id]="'st-result-type-container-9' + loop_idx_1" class="result-type-container">
                <span class="result-type" [class.live]="result.isLive">{{
                  result.type
                  }}</span>
                <!-- <span class="result-live-indicator" *ngIf="result.isLive">● Live</span> -->
                <svg class="result-arrow" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>
          <div id="st-desktop-search-loading" class="search-dropdown" *ngIf="
              isSearchExpanded &&
              searchQuery.length > 0 &&
              isSearchLoading &&
              searchResults.length === 0
            ">
            <div class="search-result-item">
              <stupa-skeleton-loader [rows]="3" [columns]="1" />
            </div>
          </div>
        </div>
        <button type="button" id="st-header_language-10" class="header_language" *ngIf="!isSearchExpanded"
          (click)="openLanguageOverlay($event)">
          <svg class="stupa-svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="9" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <path d="M12 3c2.5 2.6 2.5 15.4 0 18M12 3c-2.5 2.6-2.5 15.4 0 18" />
          </svg>
        </button>

        <app-notification-manager *ngIf="is_login && !isSearchExpanded && showNotifyUsers" />

        <div *ngIf="isThemeSwitchAvailable && !isSearchExpanded" class="header_theme"
          (click)="openThemeOverlay($event)">
          <div id="st-header_theme-11" *ngIf="isThemeSwitchAvailable" class="header_theme"
            (click)="openThemeOverlay($event)">
            <svg class="stupa-svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="4.5" />
              <path
                d="M12 2v2M12 20v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M2 12h2M20 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4" />
            </svg>
          </div>
        </div>

        <button type="button" id="st-header_user-12" class="header_user" (click)="openProfileOverlay($event)">
          <img *ngIf="is_login && profileStore.profilePic() && !avatarError" class="header-avatar"
            [src]="profileStore.profilePic()" alt="profile" (error)="avatarError = true" />
          <svg *ngIf="!is_login || !profileStore.profilePic() || avatarError" class="stupa-svg" width="20" height="20"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="8" r="4" />
            <path d="M4 21c0-4.2 3.6-7 8-7s8 2.8 8 7" />
          </svg>
        </button>
      </div>



      <div class="gap-3 d-flex align-items-center" *ngIf="innerWidth < 1024">
        <app-notification-manager *ngIf="is_login && showNotifyUsers" />


        <div id="st-container-13" class="gap-3 d-flex align-items-center" *ngIf="innerWidth < 1024">
          <div *ngIf="isThemeSwitchAvailable" class="header_theme" (click)="openThemeOverlay($event)">
            <svg class="stupa-svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="4.5" />
              <path
                d="M12 2v2M12 20v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M2 12h2M20 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4" />
            </svg>
          </div>
          <button type="button" class="mobile-search-btn" style="margin-top: 5px;" (click)="toggleSearch()">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.5 0C8.22391 0 9.87721 0.684819 11.0962 1.90381C12.3152 3.12279 13 4.77609 13 6.5C13 8.11 12.41 9.59 11.44 10.73L11.71 11H12.5L17.5 16L16 17.5L11 12.5V11.71L10.73 11.44C9.55037 12.4465 8.05065 12.9996 6.5 13C4.77609 13 3.12279 12.3152 1.90381 11.0962C0.684819 9.87721 0 8.22391 0 6.5C0 4.77609 0.684819 3.12279 1.90381 1.90381C3.12279 0.684819 4.77609 0 6.5 0ZM6.5 2C4 2 2 4 2 6.5C2 9 4 11 6.5 11C9 11 11 9 11 6.5C11 4 9 2 6.5 2Z"
                fill="#AEB5BE"></path>
            </svg>
          </button>



          <button class="navbar-toggler" type="button" aria-controls="navbarSupportedContent" aria-expanded="false"
            #toggleButton (click)="showSidebar(toggleButton)">
            <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0.4375H18V2.4375H0V0.4375ZM0 5.4375H18V7.4375H0V5.4375ZM0 10.4375H18V12.4375H0V10.4375Z"
                fill="#AEB5BE" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </nav>
</div>

<!-- Mobile Search Overlay -->
<div id="st-mobile-search-overlay" class="mobile-search-overlay" *ngIf="innerWidth <= 1024 && isSearchExpanded">
  <div id="st-mobile-search-header-14" class="mobile-search-header">
    <div id="st-container-15" class="gap-2 d-flex align-items-center">
      <span class="search-icon-header">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
            stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M21 21L16.65 16.65" stroke="#667085" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </span>
      <span class="search-title">{{'search'|translate}}</span>
    </div>
    <button class="close-btn" (click)="toggleSearch()">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="#667085" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>
  </div>

  <div id="st-mobile-search-body-16" class="mobile-search-body">
    <div id="st-mobile-search-input-container-17" class="mobile-search-input-container">
      <svg class="search-input-icon" width="18" height="18" viewBox="0 0 18 18" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.5 0C8.22391 0 9.87721 0.684819 11.0962 1.90381C12.3152 3.12279 13 4.77609 13 6.5C13 8.11 12.41 9.59 11.44 10.73L11.71 11H12.5L17.5 16L16 17.5L11 12.5V11.71L10.73 11.44C9.55037 12.4465 8.05065 12.9996 6.5 13C4.77609 13 3.12279 12.3152 1.90381 11.0962C0.684819 9.87721 0 8.22391 0 6.5C0 4.77609 0.684819 3.12279 1.90381 1.90381C3.12279 0.684819 4.77609 0 6.5 0ZM6.5 2C4 2 2 4 2 6.5C2 9 4 11 6.5 11C9 11 11 9 11 6.5C11 4 9 2 6.5 2Z"
          fill="currentColor" />
      </svg>
      <input type="text" class="mobile-search-input" [placeholder]="'search_placeholder' | translate"
        [(ngModel)]="searchQuery" (input)="onSearchInput($event)" autofocus />
      <!-- Mobile Microphone button (only show if voice search is supported) -->
      <button class="mobile-mic-btn" *ngIf="isVoiceSearchSupported && false" [class.listening]="isListening"
        (click)="startVoiceSearch()" title="Voice Search">
        <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7 11C8.66 11 9.99 9.66 9.99 8L10 3C10 1.34 8.66 0 7 0C5.34 0 4 1.34 4 3V8C4 9.66 5.34 11 7 11ZM12.3 8C12.3 11 9.76 13.1 7 13.1C4.24 13.1 1.7 11 1.7 8H0C0 11.41 2.72 14.23 6 14.72V18H8V14.72C11.28 14.24 14 11.42 14 8H12.3Z"
            [attr.fill]="isListening ? '#F04438' : 'currentColor'" />
        </svg>
      </button>
    </div>

    <div id="st-mobile-search-results-list" class="mobile-search-results" *ngIf="searchResults.length > 0">
      <button type="button" [id]="'st-mobile-result-item' + loop_idx_2" class="mobile-result-item"
        *ngFor="let result of searchResults; let loop_idx_2 = index; trackBy: trackByIndex"
        (click)="onResultClick(result)">
        <div id="st-container-18" class="d-flex justify-content-between align-items-center w-100">
          <span class="mobile-result-name">{{ result.name }}</span>
          <div id="st-container-19" class="gap-2 d-flex align-items-center">
            <span class="mobile-result-type" [class.live]="result.isLive">{{ result.type }}</span>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 17L17 7M17 7H7M17 7V17" stroke="#667085" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
        </div>
      </button>
    </div>

    <div id="st-mobile-search-loading" class="mobile-search-results" *ngIf="isSearchLoading && searchResults.length === 0">
      <stupa-skeleton-loader [rows]="3" [columns]="1" />
    </div>

    <div id="st-no-results-20" class="no-results"
      *ngIf="searchResults.length === 0 && searchQuery.length >= 3 && !isSearchLoading">
      {{'no_results_found'|translate}}
    </div>
  </div>
</div>
<div id="st-toggler-sidebar-21" class="toggler-sidebar">
  <p-sidebar id="st-mobile-nav-sidebar" [(visible)]="show_sidebar" position="bottom"
    (visibleChange)="onNavSidebarVisibleChange($event)">
    <div id="st-sidebar-drag-sheet-22" class="sidebar-drag-sheet" [class.sidebar-drag-sheet--snap]="sidebarPanSnap"
      [style.transform]="sidebarPanSheetTransform">
      <div id="st-sidebar-tab-line-host-23" class="sidebar-tab-line-host" tabindex="0"
        aria-label="Pull down along this bar to close the menu" (pointerdown)="onSidebarPanHandle($event)"
        (pointermove)="onSidebarPanHandle($event)" (pointerup)="onSidebarPanHandle($event)"
        (pointercancel)="onSidebarPanHandle($event)">
        <span class="sidebar-tab-line" aria-hidden="true"></span>
      </div>
      <div id="st-sidebar-tab-block-24" class="sidebar-tab-block d-flex flex-column">
        <button type="button" id="st-sidebar-tab-box-25" class="sidebar-tab-box"
          (click)="navigateToRegistration('/home'); show_sidebar = false">
          <p [ngClass]="_currentRoute == 'home' ? 'selected' : ''">{{'home' | translate}}</p>
        </button>
        <button type="button" id="st-sidebar-tab-box-26" class="sidebar-tab-box"
          (click)="navigateToRegistration('/events/1'); show_sidebar = false">
          <p [ngClass]="_currentRoute == 'events' ? 'selected' : ''">{{'events' | translate}}</p>
        </button>
        <button type="button" id="st-sidebar-tab-box-27" *ngIf="show_live" class="sidebar-tab-box"
          (click)="navigateToRegistration('/live'); show_sidebar = false">
          <p [ngClass]="_currentRoute == 'live' ? 'selected' : ''">{{'live' | translate}}</p>
        </button>
        <button type="button" id="st-sidebar-tab-box-28" *ngIf="show_broadcasts" class="sidebar-tab-box"
          (click)="navigateToRegistration('/broadcasts/4'); show_sidebar = false">
          <p [ngClass]="_currentRoute == 'broadcasts' ? 'selected' : ''">{{'video_collection' | translate}}</p>
        </button>

        <button type="button" id="st-sidebar-tab-box-29" class="sidebar-tab-box"
          (click)="navigateToRegistration('/videos'); show_sidebar = false" *ngIf="false">
          <p [ngClass]="_currentRoute == 'videos' ? 'selected' : ''">
            {{ "videos" | translate }}
          </p>
        </button>

        <button type="button" id="st-sidebar-tab-box-30" class="sidebar-tab-box"
          (click)="navigateToRegistration('/ranking'); show_sidebar = false" *ngIf="useRanking">
          <p [ngClass]="_currentRoute == 'ranking' ? 'selected' : ''">
            {{ "ranking" | translate }}</p>
        </button>
        <button type="button" id="st-sidebar-tab-box-31" class="sidebar-tab-box" *ngIf="showSubLicense"
          (click)="navigateToRegistration('/sub-licenses'); show_sidebar = false">
          <p [ngClass]="_currentRoute == 'sub-licenses' ? 'selected' : ''"> {{'sub_license' | translate}}</p>
        </button>
        <button type="button" id="st-sidebar-tab-box-32" *ngIf="is_membership_available" class="sidebar-tab-box"
          (click)="navigateToMembership(); show_sidebar = false">
          <p [ngClass]="_currentRoute == 'membership' ? 'selected' : ''">{{'license'|translate|titlecase}}</p>
        </button>
        <button type="button" id="st-sidebar-tab-box-33" class="sidebar-tab-box"
          (click)="navigateToRegistration('/rating'); show_sidebar = false" *ngIf="useRating">
          <p [ngClass]="_currentRoute == 'rating' ? 'selected' : ''">{{'rating' | translate}}</p>
        </button>
        <div id="st-sidebar-tab-box-34" class="gap-4 sidebar-tab-box d-flex flex-column">
          <button type="button" id="st-container-35" class="flex-row gap-2 d-flex align-items-center"
            (click)="toggleDropDownMenuItem('language')">
            <p [ngClass]="_currentRoute == 'language' ? 'tab-selected' : ''">
              {{ 'language' | translate }}
            </p>
            <svg width="24" height="12" viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_5081_98510)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12.7109 1.84306L18.3679 7.50006L16.9539 8.91406L12.0039 3.96406L7.05389 8.91406L5.63989 7.50006L11.2969 1.84306C11.4844 1.65559 11.7387 1.55028 12.0039 1.55028C12.2691 1.55028 12.5234 1.65559 12.7109 1.84306Z"
                  fill="var(--blue_black_to_white)" />
              </g>
              <defs>
                <clipPath id="clip0_5081_98510">
                  <rect width="12" height="24" fill="white" transform="matrix(0 -1 1 0 0 12)" />
                </clipPath>
              </defs>
            </svg>
            <!-- <img [ngStyle]="{
              transform:
                openDropDownMenu === 'language' ? 'none' : 'rotate(180deg)'
            }" src="../../../assets/icons_svg/weui_arrow-filled.svg" alt="drop arrow" /> -->
          </button>
          <div id="st-container-36" class="gap-3 d-flex flex-column" *ngIf="openDropDownMenu === 'language'">
            <p [id]="'st-mobile-lang-item' + loop_idx_3"
              *ngFor="let lang of availableLanguages; let loop_idx_3 = index; trackBy: trackByIndex"
              (click)="selectLanguage(lang.code); show_sidebar = false"
              [ngClass]="{'tab-selected': currentLang === lang.code}">
              {{ lang.name }}
            </p>
          </div>
        </div>

        <div id="st-sidebar-tab-box-37" class="gap-3 sidebar-tab-box d-flex flex-column">
          <button type="button" id="st-container-38" class="flex-row gap-2 d-flex align-items-center"
            (click)="toggleDropDownMenuItem('profile')">
            <p [ngClass]="_currentRoute == 'profile' ? 'tab-selected' : ''">
              {{ "more" | translate | titlecase }}
            </p>
            <svg width="24" height="12" viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_5081_98510)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12.7109 1.84306L18.3679 7.50006L16.9539 8.91406L12.0039 3.96406L7.05389 8.91406L5.63989 7.50006L11.2969 1.84306C11.4844 1.65559 11.7387 1.55028 12.0039 1.55028C12.2691 1.55028 12.5234 1.65559 12.7109 1.84306Z"
                  fill="var(--blue_black_to_white)" />
              </g>
              <defs>
                <clipPath id="clip0_5081_98510">
                  <rect width="12" height="24" fill="white" transform="matrix(0 -1 1 0 0 12)" />
                </clipPath>
              </defs>
            </svg>
            <!-- <img [ngStyle]="{
              transform:
                openDropDownMenu === 'profile' ? 'none' : 'rotate(180deg)'
            }" src="../../../assets/icons_svg/weui_arrow-filled.svg" alt="drop arrow" /> -->
          </button>
          <div id="st-container-39" class="gap-3 d-flex flex-column" *ngIf="openDropDownMenu === 'profile'">
            <p [ngClass]="_currentRoute == 'english' ? 'tab-selected' : ''"
              (click)="navigate_to_web(); show_sidebar = false" *ngIf="show_tabs()">
              {{ "switch_to_admin" | translate }}
            </p>
            <p [ngClass]="_currentRoute == 'swedish' ? 'tab-selected' : ''" (click)="
              navigateToRegistration('/registration'); show_sidebar = false
            " *ngIf="show_tabs()">
              {{ "registration" | translate }}
            </p>
            <p [ngClass]="
              _currentRoute == 'request-management' ? 'tab-selected' : ''
            " (click)="navigateToRequestManagement(); show_sidebar = false" *ngIf="show_tabs()">
              {{ "request_management" | translate }}
            </p>
            <p [ngClass]="_currentRoute == 'my-registration' ? 'tab-selected' : ''" (click)="navigateToMyRegistration()"
              (mouseenter)="prefetchMyRegistrationModule()" *ngIf="show_tabs()">
              {{ "my_registration" | translate }}
            </p>
            <p [ngClass]="_currentRoute == 'new-registration' ? 'tab-selected' : ''"
              (click)="navigateToNewRegistrationHistory()" *ngIf="show_tabs()">
              {{ "new_registration" | translate }}
            </p>
            <p [ngClass]="isUserMembershipsRoute() ? 'tab-selected' : ''"
              (click)="navigateToUserMemberships(); show_sidebar = false" *ngIf="show_tabs() && isPlayer">
              {{ "my_membership" | translate }}
            </p>
            <p [ngClass]="isInvoiceHistoryRoute() ? 'tab-selected' : ''"
              (click)="navigateToInvoiceHistory(); show_sidebar = false"
              *ngIf="show_tabs() && showInvoiceHistoryInProfile">
              {{ "invoice_history" | translate }}
            </p>
            <!-- <p [ngClass]="
              _currentRoute == 'membership_order_history' ? 'tab-selected' : ''
            " (click)="navigateToOrderHistory(); show_sidebar = false" *ngIf="show_tabs()">
            {{ "membership_order_history" | translate }}
          </p> -->
            <p [ngClass]="is_login ? 'tab-selected' : ''" (click)="navigate_to_login(); show_sidebar = false"
              *ngIf="!show_tabs()">
              {{ "login" | translate }}
            </p>

            @for(item of profile_list;track item.id ; let i = $index ){
            <p [ngClass]="_currentRoute == 'portugese' ? 'tab-selected' : ''"
              (click)="selectProfile({ value: item.id }); show_sidebar = false" *ngIf="show_tabs()">
              {{ item.name | translate }}
            </p>
            }
          </div>
        </div>
        <button type="button" id="st-sidebar-tab-box-40" class="sidebar-tab-box"
          (click)="toggleTheme(); show_sidebar = false">
          <p [ngClass]="_currentRoute == 'switch_theme' ? 'selected' : ''">
            {{ "switch_theme" | translate }}
          </p>
        </button>
      </div>
    </div>
  </p-sidebar>
  <p-overlayPanel id="st-profile-dropdown-overlay" #profileOverlay styleClass="profile-overlay">
    <div id="st-header_overlay_dialog-41" class="header_overlay_dialog">
      <button class="headerTab f_500 f_14 w-100 text-start" (click)="toggleTheme()">
        <i class="bi bi-circle-half"></i>
        <span class="ht-label">{{ "switch_theme" | translate }}</span>
      </button>
      <button class="headerTab f_500 f_14 w-100 text-start" (click)="navigate_to_login()" *ngIf="!show_tabs()">
        <i class="bi bi-box-arrow-in-right"></i>
        <span class="ht-label">{{ "login" | translate }}</span>
      </button>
      <button class="headerTab f_500 f_14 w-100 text-start" (click)="navigate_to_web()" *ngIf="show_tabs() && is_admin">
        <i class="bi bi-shield-lock"></i>
        <span class="ht-label">{{ "switch_to_admin" | translate }}</span>
      </button>
      <button class="headerTab f_500 f_14 w-100 text-start" (click)="navigateToRegistration('/registration')"
        *ngIf="show_tabs()">
        <i class="bi bi-clipboard-check"></i>
        <span class="ht-label">{{ "registration" | translate }}</span>
      </button>
      <!-- <button class="headerTab f_500 f_14 w-100 text-start" (click)="navigateToOrderHistory()" *ngIf="show_tabs()">
        {{'membership_order_history' | translate}}
      </button> -->
      <button class="headerTab f_500 f_14 w-100 text-start" (click)="navigateToUserMemberships()"
        *ngIf="show_tabs() && isPlayer">
        <i class="bi bi-person-badge"></i>
        <span class="ht-label">{{ "my_membership" | translate }}</span>
      </button>
      <button class="headerTab f_500 f_14 w-100 text-start" (click)="navigateToInvoiceHistory()"
        *ngIf="show_tabs() && showInvoiceHistoryInProfile">
        <i class="bi bi-receipt"></i>
        <span class="ht-label">{{ "invoice_history" | translate }}</span>
      </button>
      <button class="headerTab f_500 f_14 w-100 text-start" (click)="navigateToRequestManagement()" *ngIf="show_tabs()">
        <i class="bi bi-inbox"></i>
        <span class="ht-label">{{ "request_management" | translate }}</span>
      </button>
      <button class="headerTab f_500 f_14 w-100 text-start" (click)="navigateToMyRegistration()"
        (mouseenter)="prefetchMyRegistrationModule()" *ngIf="show_tabs()">
        <i class="bi bi-person-vcard"></i>
        <span class="ht-label">{{ "my_registration" | translate }}</span>
      </button>
      <button class="headerTab f_500 f_14 w-100 text-start" (click)="navigateToNewRegistrationHistory()"
        *ngIf="show_tabs()">
        <i class="bi bi-clock-history"></i>
        <span class="ht-label">{{ "new_registration" | translate }}</span>
      </button>
      @for(item of profile_list;track item.id ; let i = $index ){
      <button class="headerTab f_500 f_14 w-100 text-start" (click)="selectProfile({ value: item.id })"
        *ngIf="show_tabs()">
        <!-- id 3 = logout → exit icon; everything else keeps the profile icon -->
        <i class="bi" [ngClass]="item.id === 3 ? 'bi-box-arrow-right' : 'bi-person-circle'"></i>
        <span class="ht-label">{{ item.name | translate }}</span>
      </button>
      }
      <!-- <button class="mt-2 headerTab f_500 f_14 w-100 text-start" (click)="selectProfile({value:2})" value="2">Order History</button>
        <button class="mt-2 headerTab f_500 f_14 w-100 text-start" (click)="selectProfile({value:3})" value="3">Log Out</button> -->
    </div>
  </p-overlayPanel>
</div>

<p-overlayPanel id="st-language-dropdown-overlay" #languageOverlay styleClass="language-overlay">
  <div id="st-header_overlay_dialog-42" class="header_overlay_dialog">
    <button [id]="'st-desktop-lang-item' + loop_idx_4"
      *ngFor="let lang of availableLanguages; let loop_idx_4 = index; trackBy: trackByIndex"
      class="headerTab f_500 f_14 w-100 text-start" [class.selected]="currentLang === lang.code"
      (click)="selectLanguage(lang.code)">
      <i class="bi bi-translate"></i>
      <span class="ht-label">{{ lang.name }}</span>
      <i class="bi bi-check2 ht-check" *ngIf="currentLang === lang.code"></i>
    </button>
  </div>
</p-overlayPanel>

<p-overlayPanel id="st-theme-dropdown-overlay"
  *ngIf="tenant_name=='preprod' || tenant_name=='staging' || tenant_name=='dev'" #themeOverlay
  styleClass="theme-overlay">
  <div id="st-header_overlay_dialog-43" class="header_overlay_dialog">
    <button [id]="'st-desktop-theme-item' + loop_idx_5"
      *ngFor="let theme of availableThemes; let loop_idx_5 = index; trackBy: trackByIndex"
      class="headerTab f_500 f_14 w-100 text-start" [class.selected]="currentTheme === theme.value"
      (click)="selectTheme(theme.value)">
      <span class="theme-swatch" [ngClass]="'sw-' + theme.value" aria-hidden="true"></span>
      <span class="ht-label">{{ theme.label }}</span>
      <i class="bi bi-check2 ht-check" *ngIf="currentTheme === theme.value"></i>
    </button>
  </div>
</p-overlayPanel>